import { PERMISSIONS } from './permissions'

export abstract class AppRoutes {
	// Main module routes
	public static readonly DASHBOARD = '/feature/dashboard'
	public static readonly RECRUITING = '/feature/recruiting'
	public static readonly AGENT_MANAGEMENT = '/feature/agentmanagement'
	public static readonly DEMO = '/DEMO'
	public static readonly COMPASS_POC_DASHBOARD = '/feature/dashboard/compass-poc'
	public static readonly HOME = '/'
	public static readonly FEATURE = '/feature'
	public static readonly TERMS_AND_CONDITIONS = '/feature/termsandconditions'

	// Recruiting specific routes
	public static readonly RECRUITING_PROSPECT_PIPELINE = '/feature/recruiting/pipeline'
	public static readonly RECRUITING_NURTURING = '/feature/recruiting/nurturing'
	public static readonly RECRUITING_MLS_SEARCH = '/feature/recruiting/mlssearch'
	public static readonly RECRUITING_MLS_SEARCH_AGENT_PROFILE = '/feature/recruiting/mlssearch/agentprofile'

	// Error routes and Auth routes
	public static readonly ERROR_AUTHENTICATION = '/auth/error'

	public static readonly AUTH_SIGNOUT = '/auth/signout'
	public static readonly AUTH_SIGNIN = '/auth/signin'

	// Welcome (pre-auth landing page)
	public static readonly WELCOME = '/feature/welcome'

	// Company selection route
	public static readonly COMPANY_SELECTION = '/feature/company'

	// Canny routes
	public static readonly CANNY_FEEDBACK = '/feature/feedback'
	public static readonly CANNY_BOARD_DEV = 'https://realogy-product.canny.io/broker-workplace-non-prod'
	public static readonly CANNY_BOARD_PROD = 'https://realogy-product.canny.io/brokerworkplace'
}

/**
 * Route configuration for permission-based access control
 * Single source of truth for route permissions and access levels
 */
export const ROUTE_CONFIG = {
	/**
	 * Public routes - accessible without permission checks.
	 * These bypass both middleware auth and route-guard permission gates.
	 */
	PUBLIC_ROUTES: [
		AppRoutes.HOME,
		AppRoutes.AUTH_SIGNIN,
		AppRoutes.AUTH_SIGNOUT,
		AppRoutes.ERROR_AUTHENTICATION,
		AppRoutes.TERMS_AND_CONDITIONS,
		AppRoutes.WELCOME,
		'/api/auth',
	] as const,

	/**
	 * Permission-guarded paths with required permissions
	 * Map of route path to required permission strings
	 */
	PERMISSION_GUARDED_PATHS: new Map<string, string[]>([
		[AppRoutes.DASHBOARD, [PERMISSIONS.BROKER_ADMIN_USER]],
		[AppRoutes.RECRUITING_PROSPECT_PIPELINE, [PERMISSIONS.RECRUITING_USER]],
		[AppRoutes.RECRUITING_MLS_SEARCH, [PERMISSIONS.RECRUITING_USER]],
		[AppRoutes.RECRUITING, [PERMISSIONS.RECRUITING_USER]],
		[AppRoutes.AGENT_MANAGEMENT, [PERMISSIONS.OFFICE_MANAGER_USER]],
		[AppRoutes.DEMO, [PERMISSIONS.CORE_USER]],
	]),
} as const
